import { Card } from "../../../../../components/Card";
import { Icon, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Fragment } from "react";

function SuitsAgainstGovernments() {
  const suitsList = [
    {
      name: "Just Transition",
      numberOfLawSuits: 10,
      link: "http://climatecasechart.com/non-us-case-category/just-transition/",
      subItems: []
    },
    {
      name: "Energy and power",
      numberOfLawSuits: 15,
      link: "http://climatecasechart.com/non-us-case-category/energy-and-power/",
      subItems: []
    },
    {
      name: "Environmental Crimes",
      numberOfLawSuits: 2,
      link: "http://climatecasechart.com/non-us-case-category/environmental-crimes/",
      subItems: []
    },
    {
      name: "Trade and Investment",
      numberOfLawSuits: 26,
      link: "",
      subItems: [
        {
          name: "Climate-justified measures",
          numberOfLawSuits: 13,
          link: "http://climatecasechart.com/non-us-case-category/climate-justified-measures/"
        },
        {
          name: "Rollback of climate-justified measures",
          numberOfLawSuits: 7,
          link: "http://climatecasechart.com/non-us-case-category/rollback-of-climate-justified-measures/"
        },
        {
          name: "Environmental permitting",
          numberOfLawSuits: 6,
          link: "http://climatecasechart.com/non-us-case-category/environmental-permitting/"
        }
      ]
    },
    {
      name: "GHG Emissions reduction and trading",
      numberOfLawSuits: 211,
      link: "",
      subItems: [
        {
          name: "EU ETS",
          numberOfLawSuits: 66,
          link: "http://climatecasechart.com/non-us-case-category/eu-ets/"
        },
        {
          name: "Kyoto Protocol",
          numberOfLawSuits: 13,
          link: "http://climatecasechart.com/non-us-case-category/kyoto-protocol/"
        },
        {
          name: "Other",
          numberOfLawSuits: 116,
          link: "http://climatecasechart.com/non-us-case-category/other/"
        }
      ]
    },
    {
      name: "Access to information",
      numberOfLawSuits: 16,
      link: "http://climatecasechart.com/non-us-case-category/access-to-information/",
      subItems: []
    },
    {
      name: "Environmental assessment and permitting",
      numberOfLawSuits: 228,
      link: "",
      subItems: [
        {
          name: "Natural resource extraction",
          numberOfLawSuits: 67,
          link: "http://climatecasechart.com/non-us-case-category/natural-resource-extraction/"
        },
        {
          name: "Utilities",
          numberOfLawSuits: 26,
          link: "http://climatecasechart.com/non-us-case-category/utilities/"
        },
        {
          name: "Renewable projects",
          numberOfLawSuits: 40,
          link: "http://climatecasechart.com/non-us-case-category/renewable-projects/"
        },
        {
          name: "Climate adaptation",
          numberOfLawSuits: 50,
          link: "http://climatecasechart.com/non-us-case-category/climate-adaptation/"
        },
        {
          name: "Other projects",
          numberOfLawSuits: 45,
          link: "http://climatecasechart.com/non-us-case-category/other-projects/"
        }
      ]
    },
    {
      name: "Human rights",
      numberOfLawSuits: 124,
      link: "",
      subItems: [
        {
          name: "Youth/children",
          numberOfLawSuits: 21,
          link: "http://climatecasechart.com/non-us-case-category/youth-children/"
        },
        {
          name: "Other",
          numberOfLawSuits: 54,
          link: "http://climatecasechart.com/non-us-case-category/other-human-rights/"
        },
        {
          name: "Right to a healthy environment",
          numberOfLawSuits: 32,
          link: "http://climatecasechart.com/non-us-case-category/right-to-a-healthy-environment/"
        },
        {
          name: "Climate migration",
          numberOfLawSuits: 5,
          link: "http://climatecasechart.com/non-us-case-category/climate-migration/"
        },
        {
          name: "Women",
          numberOfLawSuits: 2,
          link: "http://climatecasechart.com/non-us-case-category/women/"
        },
        {
          name: "Indigenous groups",
          numberOfLawSuits: 10,
          link: "http://climatecasechart.com/non-us-case-category/indigenous-groups/"
        }
      ]
    },
    {
      name: "Failure to adapt",
      numberOfLawSuits: 11,
      link: "http://climatecasechart.com/non-us-case-category/failure-to-adapt/",
      subItems: []
    },
    {
      name: "Protecting biodiversity and ecosystems",
      numberOfLawSuits: 23,
      link: "http://climatecasechart.com/non-us-case-category/protecting-biodiveristy-and-ecosystems/",
      subItems: []
    },
    {
      name: "Public Assembly",
      numberOfLawSuits: 0,
      link: "http://climatecasechart.com/non-us-case-category/public-assembly/",
      subItems: []
    },
    {
      name: "Public trust",
      numberOfLawSuits: 5,
      link: "http://climatecasechart.com/non-us-case-category/public-trust/",
      subItems: []
    }
  ];

  return (
    <Card>

      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th isNumeric colSpan={2}>Number of law suits</Th>
            </Tr>
          </Thead>
          <Tbody>
            {suitsList.map((item, index) => (<Fragment key={index}>
              <Tr>
                <Td>
                  <Text fontWeight="bold">
                    {item.name}
                  </Text>
                </Td>
                <Td isNumeric>
                  <Text fontWeight="bold" marginInlineEnd="15px">{item.numberOfLawSuits}</Text>
                </Td>
                <Td isNumeric w="100px">
                  {item.link && (<a href={item.link} target="_blank" rel="noopener noreferrer">
                    <Icon
                      marginInlineEnd="16px"
                      as={FaExternalLinkAlt}
                      inlineSize="4"
                      blockSize="4"
                    />
                  </a>)}
                </Td>
              </Tr>

              {item.subItems.length !== 0 && (
                <Tr>
                  <Td colSpan={3}>
                    <Table variant="striped" colorScheme="gray" size="sm">
                      <Tbody>
                        {item.subItems.map((subItem, subItemIndex) => {
                          return <Tr key={"subItem" + subItemIndex}>
                            <Td>
                              <Text>
                                {subItem.name}
                              </Text>
                            </Td>
                            <Td isNumeric>
                              <Text>{subItem.numberOfLawSuits}</Text>
                            </Td>
                            <Td w="100px" isNumeric>
                              <a href={subItem.link} target="_blank" rel="noopener noreferrer">
                                <Icon
                                  as={FaExternalLinkAlt}
                                  inlineSize="4"
                                  blockSize="4"
                                />
                              </a>
                            </Td>
                          </Tr>;
                        })}
                      </Tbody>
                    </Table>
                  </Td>
                </Tr>
              )}

            </Fragment>))}

          </Tbody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default SuitsAgainstGovernments;